<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10 page-container">
          <b-row v-if="id" id="g-is_active" class="mb-5" align-v="end">
            <b-col class="col-end">
              <div style="display: block">
                <b-form-checkbox
                  switch
                  size="lg"
                  :disabled="
                    !disable_form &&
                      (form.liff_id_before_loading === '' ||
                        form.liff_id_before_loading === null)
                  "
                  v-model="form.is_active"
                  @change="toggleIsActive"
                  name="is_active"
                >
                  <span
                    v-html="
                      form.is_active
                        ? '<span style=color:green>เปิดการใช้งาน</span>'
                        : '<span style=color:red;>ปิดการใช้งาน</span>'
                    "
                  >
                  </span>
                </b-form-checkbox>

                <b-form-text
                  id="input-live-help"
                  v-if="
                    form.liff_id_before_loading === '' ||
                      form.liff_id_before_loading === null
                  "
                >
                  {{ $t("PAGE.CAMPAIGN.FORM.HINT.IS_ACTIVE") }}
                </b-form-text>
              </div>
            </b-col>
          </b-row>
          <b-form @submit.stop.prevent="onSubmit()">
            <div>
              <!-- Tabs with card integration -->
              <b-card no-body>
                <b-tabs card>
                  <b-tab
                    id="t-general"
                    :title="
                      this.$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.GENERAL')
                    "
                    @click="is_submit = true"
                    active
                  >
                    <b-card-text>
                      <b-row v-if="id" id="g-liff_id" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>LINE LIFF ID</h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <b-form-input
                            id="liff-id-input"
                            name="liff-id-input"
                            v-model="form.liff_id"
                            :disabled="disable_form"
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row v-if="id" id="g-campaign_url" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{
                                this.$t(
                                  "PAGE.CAMPAIGN.TABLE.FIELDS.CAMPAIGN_URL"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <b-input-group class="mb-2">
                            <b-form-input
                              id="campaign-url-input"
                              name="campaign-url-input"
                              v-model="liff_client_url"
                              readonly
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                @click="copyText('campaign-url-input')"
                                variant="primary"
                                >Copy</b-button
                              >
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>

                      <b-row id="g-name" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>{{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}</h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <b-form-input
                            id="name-input"
                            name="name-input"
                            v-model="$v.form.name.$model"
                            :state="validateState('name')"
                            aria-describedby="name-live-feedback"
                            :disabled="disable_form"
                          ></b-form-input>

                          <b-form-invalid-feedback id="name-live-feedback">
                            <span v-if="!$v.form.name.required" class="error">
                              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                            </span>
                            <span v-if="!$v.form.name.maxLength" class="error">
                              {{
                                $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                                  max: 256
                                })
                              }}
                            </span>
                          </b-form-invalid-feedback>
                        </b-col>
                      </b-row>

                      <b-row id="g-detail" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>{{ $t("PAGE.DEFAULT.FORM.FIELDS.DETAIL") }}</h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <ckeditor
                            :editor="editor"
                            v-model="$v.form.detail.$model"
                            :state="validateState('detail')"
                            aria-describedby="name-live-feedback"
                            :disabled="disable_form"
                            :config="editorConfig"
                          ></ckeditor>

                          <b-form-invalid-feedback id="name-live-feedback">
                            <span v-if="!$v.form.detail.required" class="error">
                              {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                            </span>
                          </b-form-invalid-feedback>
                        </b-col>
                      </b-row>

                      <b-row id="g-start_date" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{ $t("PAGE.DEFAULT.FORM.FIELDS.START_DATE") }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <date-picker
                            id="start-date-datepicker"
                            v-model="$v.form.start_date.$model"
                            :disabled="disable_form"
                            :config="options"
                            autocomplete="off"
                          ></date-picker>
                          <span
                            v-if="isSubmit && !$v.form.start_date.required"
                            class="error text-danger"
                          >
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row id="g-end_date" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{ $t("PAGE.DEFAULT.FORM.FIELDS.END_DATE") }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <date-picker
                            id="end-date-datepicker"
                            v-model="$v.form.end_date.$model"
                            :disabled="disable_form"
                            :config="options"
                            autocomplete="off"
                          ></date-picker>
                          <span
                            v-if="isSubmit && !$v.form.end_date.required"
                            class="error text-danger"
                          >
                            {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row id="g-term_and_condition" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.TERM_AND_CONDITION"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <ckeditor
                            :editor="editor"
                            v-model="$v.form.term_and_condition.$model"
                            :state="validateState('term_and_condition')"
                            aria-describedby="name-live-feedback"
                            :disabled="disable_form"
                            :config="editorConfig"
                          ></ckeditor>
                        </b-col>
                      </b-row>

                      <b-row id="g-line_message_token" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.LINE_MESSAGE_TOKEN"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <b-form-textarea
                            id="line_message_token-input"
                            name="line_message_token-input"
                            v-model="form.line_message_token"
                            aria-describedby="name-live-feedback"
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                        </b-col>
                      </b-row>

                      <b-row id="g-main-image" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{ $t("PAGE.DEFAULT.FORM.FIELDS.MAIN_IMAGE") }}
                            </h5>
                          </label>
                        </b-col>
                        <b-col sm="10">
                          <b-form-file
                            v-model="form.image_file"
                            @change="handleMainImage"
                            accept="image/*"
                            :placeholder="
                              this.$t(
                                'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                              )
                            "
                            drop-placeholder="Drop file here..."
                            :disabled="disable_form"
                          ></b-form-file>
                          <div v-if="preview.image" class="mt-2">
                            <div class="row">
                              <div class="col-3">
                                <img
                                  :src="preview.image"
                                  alt="Main image"
                                  class="image-preview"
                                />
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>

                      <b-row id="g-other-image" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{ $t("PAGE.DEFAULT.FORM.FIELDS.BANNER_IMAGE") }}
                            </h5>
                          </label>
                        </b-col>
                        <b-col sm="10">
                          <b-form-file
                            v-model="form.image_file"
                            @change="handleBannerImage"
                            accept="image/*"
                            :placeholder="
                              this.$t(
                                'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                              )
                            "
                            drop-placeholder="Drop file here..."
                            :disabled="disable_form"
                          ></b-form-file>
                          <b-form-text id="input-live-help">
                            {{ $t("PAGE.CAMPAIGN.FORM.HINT.BANNER_SCALE") }}
                          </b-form-text>
                        </b-col>
                        <b-col sm="2"></b-col>
                        <b-col sm="10">
                          <div v-if="preview.images" class="row">
                            <div
                              v-for="(item, index) in preview.images"
                              :key="index"
                              class="col-6 my-2"
                            >
                              <img
                                width="414"
                                height="165"
                                :src="item.image"
                                alt="Banner image"
                                class="image-preview image-object-fit"
                              />
                              <div class="col-md-12 text-center">
                                <button
                                  type="button"
                                  :disabled="disable_form"
                                  @click="deleteBannerImage(index)"
                                  class="btn btn-danger"
                                >
                                  ลบ
                                </button>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    id="t-landing"
                    :title="
                      this.$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.LANDING')
                    "
                    @click="is_submit = true"
                  >
                    <CampaignLanding :form="form" :isSubmit="isSubmit" />
                  </b-tab>

                  <b-tab
                    id="t-termAndCondition"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.TERM_AND_CONDITION'
                      )
                    "
                    @click="is_submit = true"
                  >
                    <CampaignPolicy :form="form" :isSubmit="isSubmit" />
                  </b-tab>

                  <b-tab
                    id="t-receipt"
                    :title="
                      this.$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.RECEIPT')
                    "
                    @click="is_submit = true"
                  >
                    <b-card-text>
                      <b-row id="rc-receipt-selection" class="mb-5">
                        <b-col sm="2">
                          <label>
                            <h5>
                              {{
                                $t(
                                  "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_TYPE"
                                )
                              }}
                            </h5>
                          </label>
                        </b-col>

                        <b-col sm="10">
                          <b-form-radio-group
                            v-model="receipt_selection"
                            :options="receipt_selection_option"
                            class="mb-3"
                            value-field="item"
                            text-field="name"
                            @change="setReceiptSelection"
                            :disabled="disable_form"
                          ></b-form-radio-group>
                        </b-col>
                      </b-row>

                      <b-row id="rc-receipt-selection" class="mb-5">
                        <b-col sm="12">
                          <p v-if="!disable_form" class="ps-note">
                            * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                          </p>

                          <b-form-checkbox-group
                            size="lg"
                            id="receipt-type-input"
                            name="receipt-type"
                            v-model="$v.form.receipt_type.$model"
                            :state="validateState('receipt_type')"
                            :options="receipt_list"
                            aria-describedby="name-live-feedback"
                            stacked
                            :disabled="
                              receipt_selection == 'all' || disable_form
                            "
                          ></b-form-checkbox-group>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    id="t-product"
                    :title="
                      this.$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.PRODUCT')
                    "
                    @click="is_submit = true"
                  >
                    <b-card-text>
                      <div class="text-right mb-5">
                        <b-button
                          @click.prevent="openProductModal()"
                          variant="primary"
                          >{{ $t("PAGE.DEFAULT.FORM.BTN_ADD") }}</b-button
                        >
                      </div>

                      <b-modal
                        id="modal-product-form"
                        ref="modal"
                        :title="
                          this.$t('PAGE.CAMPAIGN.FORM.MODAL.PRODUCT_TITLE')
                        "
                        :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
                        :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
                        @hidden="resetProductModal"
                        @ok="handleSubmitProduct"
                      >
                        <form
                          ref="form"
                          @submit.stop.prevent="handleSaveProduct"
                        >
                          <b-row id="mrcp-product-name" class="mb-5">
                            <b-col sm="2">
                              <label>
                                <h5>
                                  {{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="10">
                              <b-form-input
                                id="rcp-product-name-input"
                                name="rcp-product-name-input"
                                v-model="
                                  $v.form_receipt_product.product_name.$model
                                "
                                :state="
                                  validateProductModalState('product_name')
                                "
                                aria-describedby="name-live-feedback"
                              ></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span
                                  v-if="
                                    !$v.form_receipt_product.product_name
                                      .required
                                  "
                                  class="error"
                                >
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                                <span
                                  v-if="
                                    !$v.form_receipt_product.product_name
                                      .maxLength
                                  "
                                  class="error"
                                >
                                  {{
                                    $t(
                                      "PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH",
                                      {
                                        max: 256
                                      }
                                    )
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>

                          <b-row id="mrcp-quantity" class="mb-5">
                            <b-col sm="2">
                              <label>
                                <h5>
                                  {{ $t("PAGE.DEFAULT.FORM.FIELDS.QUANTITY") }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="10">
                              <b-form-input
                                type="number"
                                min="1"
                                id="rcp-quantity-input"
                                name="rcp-quantity-input"
                                @wheel="$event.target.blur()"
                                @keypress="isNumber($event)"
                                v-model="
                                  $v.form_receipt_product.quantity.$model
                                "
                                :state="validateProductModalState('quantity')"
                                aria-describedby="name-live-feedback"
                              ></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span
                                  v-if="
                                    !$v.form_receipt_product.quantity.required
                                  "
                                  class="error"
                                >
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>

                          <b-row id="mrcp-point" class="mb-5">
                            <b-col sm="2">
                              <label>
                                <h5>
                                  {{ $t("PAGE.DEFAULT.FORM.FIELDS.POINT") }}
                                </h5>
                              </label>
                            </b-col>

                            <b-col sm="10">
                              <b-form-input
                                type="number"
                                @wheel="$event.target.blur()"
                                @keypress="isNumber($event)"
                                id="rcp-point-input"
                                name="rcp-point-input"
                                v-model="$v.form_receipt_product.point.$model"
                                :state="validateProductModalState('point')"
                                aria-describedby="name-live-feedback"
                              ></b-form-input>

                              <b-form-invalid-feedback id="name-live-feedback">
                                <span
                                  v-if="!$v.form_receipt_product.point.required"
                                  class="error"
                                >
                                  {{
                                    $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                  }}
                                </span>
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </form>
                      </b-modal>

                      <p
                        v-if="!disable_form && form.receipt_product.length == 0"
                        class="ps-note"
                      >
                        * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                      </p>

                      <div class="table-responsive">
                        <b-table
                          id="organizations-table"
                          :striped="false"
                          :items="form.receipt_product"
                          :fields="table_receipt_product.fields"
                          :borderless="false"
                          head-variant="light"
                        >
                          <template #cell(action)="data">
                            <a
                              href="javascript:"
                              @click.prevent="
                                openProductModal(data.item, data.index)
                              "
                              class="btn btn-icon btn-light btn-sm"
                              v-b-tooltip.hover
                              :title="
                                $t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')
                              "
                            >
                              <span
                                class="svg-icon svg-icon-md svg-icon-success"
                              >
                                <inline-svg
                                  src=" media/svg/icons/General/Edit.svg"
                                ></inline-svg>
                              </span> </a
                            >&nbsp;&nbsp;&nbsp;
                            <a
                              href="javascript:"
                              @click.prevent="removeReceiptProduct(data.index)"
                              class="btn btn-icon btn-light btn-sm"
                              v-b-tooltip.hover
                              :title="
                                $t(
                                  'PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE'
                                )
                              "
                            >
                              <span
                                class="svg-icon svg-icon-md svg-icon-danger"
                              >
                                <inline-svg
                                  src="media/svg/icons/General/Trash.svg"
                                ></inline-svg>
                              </span>
                            </a>
                          </template>
                        </b-table>

                        <p
                          class="text-center pt-3"
                          v-if="form.receipt_product.length < 1"
                        >
                          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                        </p>
                      </div>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    id="t-reward"
                    :title="
                      this.$t('PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.REWARD')
                    "
                    @click="is_submit = true"
                  >
                    <b-card-text>
                      <div class="text-right mb-5">
                        <b-button
                          @click.prevent="openRewardModal()"
                          variant="primary"
                          >{{ $t("PAGE.DEFAULT.FORM.BTN_ADD") }}</b-button
                        >
                      </div>
                    </b-card-text>

                    <b-modal
                      id="modal-reward-form"
                      ref="modal"
                      :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.REWARD_TITLE')"
                      :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
                      :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
                      @hidden="resetRewardModal"
                      @ok="handleSubmitReward"
                      size="lg"
                    >
                      <form ref="form" @submit.stop.prevent="handleSaveReward">
                        <b-row id="mrw-reward-name" class="mb-5">
                          <b-col sm="3">
                            <label>
                              <h5>
                                {{ $t("PAGE.DEFAULT.FORM.FIELDS.NAME") }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="9">
                            <b-form-input
                              id="rw-product-name-input"
                              name="rw-product-name-input"
                              v-model="
                                $v.form_receipt_reward.reward_name.$model
                              "
                              :state="validateRewardModalState('reward_name')"
                              aria-describedby="name-live-feedback"
                            ></b-form-input>

                            <b-form-invalid-feedback id="name-live-feedback">
                              <span
                                v-if="
                                  !$v.form_receipt_reward.reward_name.required
                                "
                                class="error"
                              >
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                              <span
                                v-if="
                                  !$v.form_receipt_reward.reward_name.maxLength
                                "
                                class="error"
                              >
                                {{
                                  $t(
                                    "PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH",
                                    {
                                      max: 256
                                    }
                                  )
                                }}
                              </span>
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>

                        <b-row id="mrw-reward-name" class="mb-5">
                          <b-col sm="3">
                            <label>
                              <h5>
                                {{
                                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.IMAGE")
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="9">
                            <b-form-file
                              ref="file-input"
                              @change="handleReceiptRewardImage($event)"
                              :state="validateRewardModalState('newImage')"
                              aria-describedby="newImage-live-feedback"
                              accept="image/*"
                              :placeholder="
                                this.$t(
                                  'PAGE.DEFAULT.FORM.PLACEHOLDER.CHOOSE_IMAGE'
                                )
                              "
                              drop-placeholder="Drop file here..."
                            ></b-form-file>
                            <b-form-invalid-feedback
                              id="newImage-live-feedback"
                            >
                              <span
                                v-if="!$v.form_receipt_reward.newImage.required"
                                class="error"
                              >
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                            </b-form-invalid-feedback>

                            <div
                              v-if="form_receipt_reward.newImage"
                              class="my-2"
                            >
                              <div class="row">
                                <div class="col-3">
                                  <img
                                    :src="form_receipt_reward.newImage"
                                    alt="Main image"
                                    class="image-preview"
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="
                                !form_receipt_reward.newImage &&
                                  form_receipt_reward.image
                              "
                              class="my-2"
                            >
                              <div class="row">
                                <div class="col-3">
                                  <img
                                    :src="
                                      `${ADMIN_IMAGE_URL}/${form_receipt_reward.image}`
                                    "
                                    alt="Main image"
                                    class="image-preview"
                                  />
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row id="mrw-reward-quantity" class="mb-5">
                          <b-col sm="3">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.QUANTITY"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="9">
                            <b-form-input
                              id="rw-product-name-input"
                              name="rw-product-name-input"
                              type="number"
                              @wheel="$event.target.blur()"
                              @keypress="isNumber($event)"
                              v-model="$v.form_receipt_reward.quantity.$model"
                              :state="validateRewardModalState('quantity')"
                              aria-describedby="name-live-feedback"
                            ></b-form-input>

                            <b-form-invalid-feedback id="name-live-feedback">
                              <span
                                v-if="!$v.form_receipt_reward.quantity.required"
                                class="error"
                              >
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>

                        <b-row id="mrw-reward-name" class="mb-5">
                          <b-col sm="3">
                            <label>
                              <h5>
                                {{
                                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.POINT")
                                }}
                              </h5>
                            </label>
                          </b-col>

                          <b-col sm="9">
                            <b-form-input
                              id="rw-product-name-input"
                              name="rw-product-name-input"
                              type="number"
                              @wheel="$event.target.blur()"
                              @keypress="isNumber($event)"
                              v-model="$v.form_receipt_reward.point.$model"
                              :state="validateRewardModalState('point')"
                              aria-describedby="name-live-feedback"
                            ></b-form-input>

                            <b-form-invalid-feedback id="name-live-feedback">
                              <span
                                v-if="!$v.form_receipt_reward.point.required"
                                class="error"
                              >
                                {{
                                  $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED")
                                }}
                              </span>
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>

                        <b-row id="mrw-reward-name" class="mb-5">
                          <b-col sm="3">
                            <label>
                              <h5>
                                {{
                                  $t(
                                    "PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.DESCRIPTION"
                                  )
                                }}
                              </h5>
                            </label>
                          </b-col>
                          <b-col sm="9">
                            <ckeditor
                              :editor="editor"
                              v-model="form_receipt_reward.description"
                              :config="editorConfig"
                            ></ckeditor>
                          </b-col>
                        </b-row>
                      </form>
                    </b-modal>

                    <p
                      v-if="!disable_form && form.receipt_reward.length == 0"
                      class="ps-note"
                    >
                      * {{ $t("PAGE.DEFAULT.FORM.PS_NOTE.MIN_RECORD") }}
                    </p>

                    <div class="table-responsive">
                      <b-table
                        id="organizations-table"
                        :striped="false"
                        :items="form.receipt_reward"
                        :fields="table_receipt_reward.fields"
                        :borderless="false"
                        head-variant="light"
                      >
                        <template #cell(quantity)="data">
                          <div class="text-right">
                            <span>{{ data.item.quantity }}</span>
                          </div>
                        </template>

                        <template #cell(point)="data">
                          <div class="text-right">
                            <span>{{ data.item.point }}</span>
                          </div>
                        </template>

                        <template #cell(action)="data">
                          <a
                            href="javascript:"
                            @click.prevent="
                              openRewardModal(data.item, data.index)
                            "
                            class="btn btn-icon btn-light btn-sm"
                            v-b-tooltip.hover
                            :title="$t('PAGE.DEFAULT.TABLE.FIELDS.ACTION.EDIT')"
                          >
                            <span class="svg-icon svg-icon-md svg-icon-success">
                              <inline-svg
                                src=" media/svg/icons/General/Edit.svg"
                              ></inline-svg>
                            </span> </a
                          >&nbsp;&nbsp;&nbsp;
                          <a
                            href="javascript:"
                            @click.prevent="removeReceiptReward(data.index)"
                            class="btn btn-icon btn-light btn-sm"
                            v-b-tooltip.hover
                            :title="
                              $t(
                                'PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.TITLE'
                              )
                            "
                          >
                            <span class="svg-icon svg-icon-md svg-icon-danger">
                              <inline-svg
                                src="media/svg/icons/General/Trash.svg"
                              ></inline-svg>
                            </span>
                          </a>
                        </template>
                      </b-table>

                      <p
                        class="text-center pt-3"
                        v-if="form.receipt_reward.length < 1"
                      >
                        {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
                      </p>
                    </div>
                  </b-tab>

                  <b-tab
                    v-if="id"
                    id="t-customer"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.CUSTOMER'
                      )
                    "
                    @click="is_submit = false"
                    lazy
                  >
                    <b-card-text>
                      <CustomerCampaignReceipt
                        :campaign_id="id"
                        :is_redeem_reward="form.is_redeem_reward"
                      ></CustomerCampaignReceipt>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    v-if="id && form.is_redeem_reward == 1"
                    id="t-receipt-reward"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.RECEIPT_REWARD'
                      )
                    "
                    @click="is_submit = false"
                    lazy
                  >
                    <b-card-text>
                      <CustomerCampaignReceiptReward
                        :campaign_id="id"
                        @changing="changeNotApproveReceiptReward"
                      ></CustomerCampaignReceiptReward>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    v-if="id"
                    id="t-send-message"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.SEND_MESSAGE'
                      )
                    "
                    @click="is_submit = false"
                    lazy
                  >
                    <b-card-text>
                      <CustomerCampaignReceiptSendMessage
                        :campaign_id="id"
                      ></CustomerCampaignReceiptSendMessage>
                    </b-card-text>
                  </b-tab>

                  <b-tab
                    v-if="id && form.is_redeem_reward == 0"
                    id="t-announce-reward"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.ANNOUNCEMENT'
                      )
                    "
                    @click="is_submit = false"
                    lazy
                  >
                    <CampaignAnnouncement :campaign_id="id" />
                  </b-tab>

                  <b-tab
                    v-if="id"
                    id="t-dashboard"
                    :title="
                      this.$t(
                        'PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB.DASHBOARD'
                      )
                    "
                    @click="is_submit = false"
                    lazy
                  >
                    <CampaignDashboard
                      :campaign_id="id"
                      :start_date="form.start_date"
                      :end_date="form.end_date"
                      :is_redeem_reward="form.is_redeem_reward"
                      :template="form.template"
                    />
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>

            <!-- Action buttons-->
            <div class="mt-5">
              <b-row v-if="is_submit">
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                    $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                  }}</b-button>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="float-right mr-3"
                    >{{ $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") }}</b-button
                  >
                </b-col>
              </b-row>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_RECEIPT_TYPE } from "@/core/services/store/receipt_type.module";
import {
  FIND_CAMPAIGN,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_ISACTIVE,
  SET_IS_CLEAR_PAGINATION
} from "@/core/services/store/campaign.module";
import { Config } from "@/core/config/variable.config";
import CustomerCampaignReceipt from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceipt.vue";
import CustomerCampaignReceiptSendMessage from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceiptSendMessage.vue";
import CampaignDashboard from "@/view/pages/campaign/campaign-receipt-form/components/CampaignDashboard.vue";
import CampaignLanding from "@/view/pages/campaign/campaign-receipt-form/components/CampaignLanding.vue";
import CampaignPolicy from "@/view/pages/campaign/campaign-receipt-form/components/CampaignPolicy.vue";
import CustomerCampaignReceiptReward from "@/view/pages/campaign/campaign-receipt-form/components/CustomerCampaignReceiptReward.vue";
import CampaignAnnouncement from "@/view/pages/campaign/campaign-receipt-form/components/CampaignAnnouncement.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage';
import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
import Autosave from '@ckeditor/ckeditor5-autosave/src/autosave';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code';
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock';
import DataFilter from '@ckeditor/ckeditor5-html-support/src/datafilter';
import DataSchema from '@ckeditor/ckeditor5-html-support/src/dataschema';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import FindAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/findandreplace';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize';
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import HtmlComment from '@ckeditor/ckeditor5-html-support/src/htmlcomment';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Link from '@ckeditor/ckeditor5-link/src/link';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import List from '@ckeditor/ckeditor5-list/src/list';
import ListProperties from '@ckeditor/ckeditor5-list/src/listproperties';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';
import MediaEmbedToolbar from '@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar';
import Mention from '@ckeditor/ckeditor5-mention/src/mention';
import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters';
import SpecialCharactersArrows from '@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows';
import SpecialCharactersCurrency from '@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency';
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
import SpecialCharactersLatin from '@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin';
import SpecialCharactersMathematical from '@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical';
import SpecialCharactersText from '@ckeditor/ckeditor5-special-characters/src/specialcharacterstext';
import StandardEditingMode from '@ckeditor/ckeditor5-restricted-editing/src/standardeditingmode';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableCaption from '@ckeditor/ckeditor5-table/src/tablecaption';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import TextPartLanguage from '@ckeditor/ckeditor5-language/src/textpartlanguage';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount';
import EmojiActivity from "@/core/plugins/emoji-activity";
import EmojiFlags from "@/core/plugins/emoji-flags";
import EmojiFood from "@/core/plugins/emoji-food";
import EmojiNature from "@/core/plugins/emoji-nature";
import EmojiObjects from "@/core/plugins/emoji-objects";
import EmojiPeople from "@/core/plugins/emoji-people";
import EmojiPlaces from "@/core/plugins/emoji-places";
import EmojiSymbols from "@/core/plugins/emoji-symbols";

export default {
  name: "CampaignReceiptForm",
  mixins: [validationMixin],
  components: {
    CustomerCampaignReceipt,
    CustomerCampaignReceiptReward,
    CustomerCampaignReceiptSendMessage,
    CampaignDashboard,
    CampaignLanding,
    CampaignPolicy,
    datePicker,
    CampaignAnnouncement
  },
  data() {
    return {
      ADMIN_IMAGE_URL: Config.ADMIN_IMAGE_URL,
       editor: ClassicEditor,
        editorConfig: {
                    plugins: [
                        Autoformat,
                        AutoImage,
                        AutoLink,
                        Autosave,
                        Base64UploadAdapter,
                        BlockQuote,
                        Bold,
                        CloudServices,
                        Code,
                        CodeBlock,
                        DataFilter,
                        DataSchema,
                        Essentials,
                        FindAndReplace,
                        FontBackgroundColor,
                        FontColor,
                        FontFamily,
                        FontSize,
                        GeneralHtmlSupport,
                        Heading,
                        Highlight,
                        HorizontalLine,
                        HtmlComment,
                        HtmlEmbed,
                        Image,
                        ImageCaption,
                        ImageInsert,
                        ImageResize,
                        ImageStyle,
                        ImageToolbar,
                        ImageUpload,
                        Indent,
                        IndentBlock,
                        Italic,
                        Link,
                        LinkImage,
                        List,
                        ListProperties,
                        MediaEmbed,
                        MediaEmbedToolbar,
                        Mention,
                        PageBreak,
                        Paragraph,
                        PasteFromOffice,
                        RemoveFormat,
                        SourceEditing,
                        SpecialCharacters,
                        EmojiPeople,
                        EmojiFood,
                        EmojiPlaces,
                        EmojiActivity,
                        EmojiFlags,
                        EmojiNature,
                        EmojiObjects,
                        EmojiSymbols,
                        SpecialCharactersArrows,
                        SpecialCharactersCurrency,
                        SpecialCharactersEssentials,
                        SpecialCharactersLatin,
                        SpecialCharactersMathematical,
                        SpecialCharactersText,
                        StandardEditingMode,
                        Strikethrough,
                        Subscript,
                        Superscript,
                        Table,
                        TableCaption,
                        TableCellProperties,
                        TableProperties,
                        TableToolbar,
                        TextPartLanguage,
                        TextTransformation,
                        TodoList,
                        Underline,
                        WordCount,
                    ],
                    toolbar: {
                        items: [
                          'heading',
                          '|',
                          'bold',
                          'underline',
                          'italic',
                          'strikethrough',
                          '|',
                          'fontSize',
                          'fontColor',
                          'fontBackgroundColor',
                          'fontFamily',
                          '|',
                          'link',
                          'imageUpload',
                          'mediaEmbed',
                          'insertTable',
                          'specialCharacters',
                          '|',
                          'undo',
                          'redo',
                          '-',
                          'horizontalLine',
                          'pageBreak',
                          'superscript',
                          'subscript',
                          'highlight',
                          '|',
                          'bulletedList',
                          'numberedList',
                          'todoList',
                          'alignment',
                          'outdent',
                          'indent',
                          'removeFormat',
                          'blockQuote'
                        ],
                        shouldNotGroupWhenFull: true
                    },
	                  language: 'en',
                    image: {
                      toolbar: [
                        'imageTextAlternative',
                        'imageStyle:inline',
                        'imageStyle:block',
                        'imageStyle:side',
                        'linkImage'
                      ]
                    },
                    table: {
                      contentToolbar: [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                      ]
                    },
                },
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      is_submit: true,
      id: null,
      preview: {
        image_default: "media/default_image.png",
        image: null,
        images: []
      },
      disable_form: false,
      isSubmit: false,
      form: {
        campaign_type_id: 1,
        liff_id: null,
        liff_id_before_loading: null,
        line_message_token: null,
        code: null,
        name: null,
        detail: null,
        start_date: null,
        end_date: null,
        is_active: false,
        is_redeem_reward: 1,
        term_and_condition: null,
        image: null,
        image_file: [],
        images: [],
        images_file: [],
        images_delete: [],
        receipt_type: [],
        receipt_product: [],
        receipt_product_delete: [],
        receipt_reward: [],
        receipt_reward_delete: [],
        landing_image: null,
        new_landing_image: null,
        new_landing_image_src: null,
        policy_image: null,
        policy: null,
        policy_not_accept: null
      },
      liff_client_url: null,
      receipt_selection: "all",
      receipt_selection_option: [
        { item: "all", name: this.$t("PAGE.DEFAULT.FORM.OPTIONS.ALL") },
        { item: "custom", name: this.$t("PAGE.DEFAULT.FORM.OPTIONS.CUSTOM") }
      ],
      receipt_list: [],
      form_receipt_product: {
        is_edit: false,
        index: null,
        product_name: "",
        quantity: "",
        point: 1
      },
      table_receipt_product: {
        fields: [
          {
            key: "product_name",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
            key_table: "product_name",
            sortable: false,
            isFilter: false
          },
          {
            key: "quantity",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.QUANTITY")}`,
            tdClass: "text-right",
            thClass: "text-right",
            key_table: "quantity",
            sortable: false,
            isFilter: false
          },
          {
            key: "point",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.POINT")}`,
            tdClass: "text-right",
            thClass: "text-right",
            key_table: "point",
            sortable: false,
            isFilter: false
          },
          {
            key: "action",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
            sortable: false,
            isFilter: false,
            tdClass: "actionField"
          }
        ]
      },
      form_receipt_reward: {
        is_edit: false,
        index: null,
        reward_name: "",
        quantity: "0",
        point: "0",
        image: null,
        newImage: null,
        description: null
      },
      table_receipt_reward: {
        fields: [
          {
            key: "reward_name",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.NAME")}`,
            key_table: "reward_name",
            sortable: false,
            isFilter: false
          },
          {
            key: "quantity",
            label: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.QUANTITY")}`,
            key_table: "quantity",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          },
          {
            key: "point",
            label: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_REWARD.POINT")}`,
            key_table: "point",
            tdClass: "text-right",
            thClass: "text-right",
            sortable: false,
            isFilter: false
          },
          {
            key: "action",
            label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
            sortable: false,
            isFilter: false,
            tdClass: "actionField"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(256)
      },
      detail: {
        required
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      term_and_condition: {},
      receipt_type: {
        required
      },
      receipt_product: {
        required
      },
      receipt_reward: {
        required
      },
      new_landing_image: {
        required: requiredIf(function() {
          return !this.form.new_landing_image && !this.form.landing_image;
        })
      },
      policy: {
        required
      },
      policy_not_accept: {
        required
      }
    },
    form_receipt_product: {
      product_name: {
        required,
        maxLength: maxLength(256)
      },
      quantity: {
        required
      },
      point: {
        required
      }
    },
    form_receipt_reward: {
      reward_name: {
        required,
        maxLength: maxLength(512)
      },
      quantity: {
        required,
        maxLength: maxLength(512)
      },
      point: {
        required,
        maxLength: maxLength(512)
      },
      newImage: {
        required: requiredIf(function() {
          return (
            !this.form_receipt_reward.newImage &&
            !this.form_receipt_reward.image
          );
        })
      }
    }
  },
  computed: {
    ...mapState({
      currentUserData: state => state.auth.currentUserData
    })
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.CAMPAIGN_MANAGEMENT.CAMPAIGN")}`,
        route: "/campaign"
      },
      {
        title: `${this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TITLE")}`
      }
    ]);
    this.id = this.$route.params.id;
    this.getReceiptType();

    if (this.id) {
      this.getCampaign(this.id);
    }
  },
  methods: {
    copyText(id) {
      let copyText = document.getElementById(id);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");

      Swal.fire({
        icon: "success",
        title: "คัดลอกข้อความเรียบร้อย",
        showConfirmButton: false,
        timer: 1000
      });
    },
    changeNotApproveReceiptReward() {
      this.getCampaign(this.id);
    },
    onChangeTabs() {
      // console.log(value);
    },
    isNumber(event) {
      if (
        !(
          event.key === "Enter" ||
          (Number(event.key) >= 0 && Number(event.key) <= 9)
        )
      ) {
        return event.preventDefault();
      }
    },
    async toggleIsActive() {
      await this.$nextTick();
      this.form.is_active = !this.form.is_active;
      Swal.fire({
        html: `${
          this.form.is_active
            ? this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFRIM_DISABLE")
            : this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFRIM_ENABLE")
        }`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then(result => {
        if (result.isConfirmed) {
          this.form.is_active = !this.form.is_active;
          this.updateDataIsActive({ is_active: this.form.is_active }, this.id);
        }
      });
    },
    getCampaign(id) {
      this.$store
        .dispatch(FIND_CAMPAIGN, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form = data.data;
            this.form.is_active = !!data.data.is_active;
            this.disable_form = this.form.is_active;

            this.form.liff_id_before_loading = data.data.liff_id;
            this.liff_client_url = `${Config.SWEEPSTAKES_LIFF_CLIENT_URL}/?id=${this.form.code}`;

            if (data.data.image) {
              this.preview.image = `${Config.ADMIN_IMAGE_URL}/${data.data.image}`;
            }

            for (let data of data.data.images) {
              data.image = `${Config.ADMIN_IMAGE_URL}/${data.image}`;
            }
            this.preview.images = [...data.data.images];

            // set other images.
            this.form.image = null;
            this.form.image_file = null;
            this.form.images_file = [];
            this.form.images_delete = [];
            this.form.receipt_product_delete = [];
            this.form.receipt_reward_delete = [];

            this.form.images = [...data.data.images];

            // set date time
            this.form.start_date = new Date(data.data.start_date);
            this.form.end_date = new Date(data.data.end_date);

            if (this.form.receipt_type.length < this.receipt_list.length) {
              this.receipt_selection = "custom";
            }

            for (const key in this.form.receipt_type) {
              this.form.receipt_type[key] = {
                receipt_type_id: this.form.receipt_type[key].receipt_type_id
              };
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    getReceiptType() {
      this.$store
        .dispatch(GET_RECEIPT_TYPE)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            for (const receipt of data.data) {
              this.receipt_list.push({
                text: receipt.name,
                value: { receipt_type_id: receipt.id }
              });
            }

            this.setReceiptSelection(this.receipt_selection);
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    setDefaultImage() {
      this.preview.image = null;
      this.preview.images = [];
    },
    handleMainImage(e) {
      const selectImage = e.target.files[0];

      if (selectImage != undefined) {
        this.encodeBase64(selectImage, "main");
      } else {
        this.setDefaultImage();
      }
    },
    handleBannerImage(e) {
      const selectImage = e.target.files[0];

      if (selectImage != undefined) {
        this.encodeBase64(selectImage, "other");
      } else {
        this.setDefaultImage();
      }
    },
    async handleReceiptRewardImage(event) {
      try {
        let source = await this.toBase64(event);
        if (source) {
          this.$v.form_receipt_reward.newImage.$model = source[0];
        }
      } catch (error) {
        //console.log(error);
      }
    },
    toBase64(event) {
      return new Promise((resolve, reject) => {
        try {
          let index = 0;
          let fileResult = [];
          const reader = new FileReader();
          reader.onload = e => {
            fileResult.push(e.target.result);
            index++;
            if (index == event.target.files.length) {
              this.$refs["file-input"].reset();
              resolve(fileResult);
            }
          };
          for (const file of event.target.files) {
            reader.readAsDataURL(file);
          }
        } catch (error) {
          reject(error.toString());
        }
      });
    },
    encodeBase64(file, type) {
      const reader = new FileReader();

      switch (type) {
        case "main":
          reader.onload = e => {
            this.form.image = e.target.result;
            this.preview.image = e.target.result;
          };
          break;
        case "other":
          reader.onload = e => {
            this.form.image_file = null;
            this.form.images.push({ image: e.target.result });
            this.preview.images.push({ image: e.target.result });
          };
          break;
      }

      reader.readAsDataURL(file);
    },
    setReceiptSelection(e) {
      if (e == "all") {
        this.receipt_type = [];

        for (const receipt of this.receipt_list) {
          this.form.receipt_type.push(receipt.value);
        }
      }
    },
    openProductModal(data = null, index = null) {
      if (data) {
        this.form_receipt_product.product_name = data.product_name;
        this.form_receipt_product.quantity = data.quantity;
        this.form_receipt_product.point = data.point;
        this.form_receipt_product.index = index;
      }

      this.$bvModal.show("modal-product-form");
    },
    validateProductModalState(name) {
      const { $dirty, $error } = this.$v.form_receipt_product[name];
      return $dirty ? !$error : null;
    },
    handleSubmitProduct(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$v.form_receipt_product.$touch();

      if (this.$v.form_receipt_product.$anyError) {
        return;
      }

      this.handleSaveProduct();
    },
    handleSaveProduct() {
      if (this.form_receipt_product.index != null) {
        let index = this.form_receipt_product.index;

        if (this.form.receipt_product[index].id) {
          this.form.receipt_product[index].is_edit = true;
        }

        this.form.receipt_product[
          index
        ].product_name = this.form_receipt_product.product_name;
        this.form.receipt_product[
          index
        ].quantity = this.form_receipt_product.quantity;
        this.form.receipt_product[
          index
        ].point = this.form_receipt_product.point;
      } else {
        this.form.receipt_product.push(this.form_receipt_product);
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-product-form");
      });
    },
    resetProductModal() {
      this.$v.$reset();
      this.form_receipt_product = {
        is_edit: false,
        index: null,
        product_name: "",
        quantity: "",
        point: 1
      };
    },
    removeReceiptProduct(index) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then(result => {
        if (result.isConfirmed) {
          if (this.form.receipt_product[index].hasOwnProperty("id")) {
            this.form.receipt_product_delete.push(
              this.form.receipt_product[index]
            );
          }

          this.form.receipt_product.splice(index, 1);
        }
      });
    },
    openRewardModal(data = null, index = null) {
      if (data) {
        this.form_receipt_reward.reward_name = data.reward_name;
        this.form_receipt_reward.quantity = data.quantity;
        this.form_receipt_reward.point = data.point;
        this.form_receipt_reward.image = data.image;
        this.form_receipt_reward.newImage = data.newImage;
        this.form_receipt_reward.description = data.description;
        this.form_receipt_reward.index = index;
      }

      this.$bvModal.show("modal-reward-form");
    },
    validateRewardModalState(name) {
      const { $dirty, $error } = this.$v.form_receipt_reward[name];
      return $dirty ? !$error : null;
    },
    handleSubmitReward(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$v.form_receipt_reward.$touch();

      if (this.$v.form_receipt_reward.$anyError) {
        return;
      }

      this.handleSaveReward();
    },
    handleSaveReward() {
      if (this.form_receipt_reward.index != null) {
        let index = this.form_receipt_reward.index;

        if (this.form.receipt_reward[index].id) {
          this.form.receipt_reward[index].is_edit = true;
        }

        this.form.receipt_reward[
          index
        ].reward_name = this.form_receipt_reward.reward_name;
        this.form.receipt_reward[index].point = this.form_receipt_reward.point;
        this.form.receipt_reward[
          index
        ].quantity = this.form_receipt_reward.quantity;
        this.form.receipt_reward[index].image = this.form_receipt_reward.image;
        this.form.receipt_reward[
          index
        ].newImage = this.form_receipt_reward.newImage;
        this.form.receipt_reward[
          index
        ].description = this.form_receipt_reward.description;
      } else {
        this.form.receipt_reward.push(this.form_receipt_reward);
      }

      this.$nextTick(() => {
        this.$bvModal.hide("modal-reward-form");
      });
    },
    resetRewardModal() {
      this.$v.$reset();
      this.form_receipt_reward = {
        is_edit: false,
        index: null,
        reward_name: "",
        quantity: "0",
        point: "0",
        image: null,
        newImage: null,
        description: null
      };
    },
    removeReceiptReward(index) {
      Swal.fire({
        text: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.DELETE.DESC")}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then(result => {
        if (result.isConfirmed) {
          if (this.form.receipt_reward[index].hasOwnProperty("id")) {
            this.form.receipt_reward_delete.push(
              this.form.receipt_reward[index]
            );
          }

          this.form.receipt_reward.splice(index, 1);
        }
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    toBase64SingleFile(event) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.onload = e => {
            resolve(e.target.result);
          };
          reader.readAsDataURL(event);
        } catch (error) {
          reject(error.toString());
        }
      });
    },
    async onSubmit() {
      this.isSubmit = true;
      this.$v.form.$touch();

      if (this.form.new_landing_image) {
        this.form.new_landing_image_src = await this.toBase64SingleFile(
          this.form.new_landing_image
        );
      }

      if (this.$v.form.$anyError) {
        Swal.fire({
          icon: "error",
          html: this.$t("PAGE.DEFAULT.FORM.VALIDATION.CHECK_DATA_ALL_TAB"),
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
        });
        return;
      }

      if (this.id) {
        this.updateData(this.form, this.id);
      } else {
        this.createData(this.form);
      }
    },
    createData(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(CREATE_CAMPAIGN, { data })
            .then(({ data }) => {
              Swal.close();
              this.isSubmit = false;
              if (data.status === "success" && data.data.message) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data.message)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.id = data.data.id;
                this.getCampaign(data.data.id);
                this.$router.push({
                  path: `/campaign/form/campaign_receipt/${data.data.id}`
                });
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              this.isSubmit = false;
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    updateData(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CAMPAIGN, { id, data })
            .then(({ data }) => {
              this.isSubmit = false;
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getCampaign(this.id);
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              this.isSubmit = false;
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    updateDataIsActive(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CAMPAIGN_ISACTIVE, { id, data })
            .then(({ data }) => {
              this.isSubmit = false;
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.getCampaign(this.id);
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              this.isSubmit = false;
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push({ path: "/campaign" });
    },
    deleteBannerImage(index) {
      if (this.form.images[index].id != null) {
        this.form.images_delete.push(this.form.images[index].id);
      }
      this.form.images.splice(index, 1);
      this.preview.images.splice(index, 1);
    }
  }
};
</script>

<style>
.image-preview {
  width: 100%;
  border: solid 1px #eee;
  border-radius: 5px;
}

.image-object-fit {
  object-fit: cover;
}

#receipt-type-input .custom-control-label {
  font-size: 1.2rem !important;
}

#receipt-type-input .custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  padding-left: 2rem;
  padding-bottom: 5px;
}

.bg-dashboard {
  background-color: rgb(141, 0, 0);
}

.col-end {
  display: flex;
  justify-content: flex-end;
}
</style>
